<template>
  <li class="col-12 col-md-6 col-lg-4">
    <div class="bg-lighter text-center rounded p-3 d-flex align-items-center justify-content-center" @click.prevent="showModal = true" style="height: 300px; cursor: pointer;">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" width="33" height="33"><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><g><path fill="#231815" d="M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"/><path fill="#231815" d="M11 9H6c-.3 0-.5-.2-.5-.5S5.7 8 6 8h5c.3 0 .5.2.5.5s-.2.5-.5.5z"/><path fill="#231815" d="M8.5 11.5c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5s.5.2.5.5v5c0 .3-.2.5-.5.5z"/></g></g></svg>
    </div>

    <!-- use the modal component, pass in the prop -->
    <modal v-if="showModal" @close="showModal = false">
      <div slot="body" class="py-0 px-md-4">
        <dashboard-form @submitBlock="newBlock = $event;addBlock()" @closeModal="showModal = false" />
      </div>
    </modal>
  </li>
</template>

<script>
import modal from '@/components/Modal'
import dashboardForm from './DashboardForm'

export default {
  name: 'DashboardNew',
  components: {
    modal,
    'dashboard-form': dashboardForm
  },
  data() {
    return {
      showModal: false,
      newBlock: { image: null }
    }
  },
  methods: {
    addBlock() {
      this.$emit('addBlock', this.newBlock)
      this.newBlock = { image: null }
      this.showModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Dashboard/DashboardNew.vue